module.exports = __webpack_public_path__ + "static/img/Fletcher.d23ecc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Fletcher.jpg
// module id = Vy3r
// module chunks = 0